/* import __COLOCATED_TEMPLATE__ from './address-input.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tagName } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import { next } from '@ember/runloop';
import { isEmpty } from '@ember/utils';
import Component from '@ember/component';
import { CountryAddressData } from '@square/dashboard-protos/models/squareup/address/country_data';
import AddressInputTypeForm from './address-input-type-form';
import AddressInputTypeFormOld from './address-input-type-form-old';
import AddressInputTypeInvertedDropdownsJP from './address-input-type-inverted-dropdowns-jp';
import AddressInputTypeInvertedDropdownsJPOld from './address-input-type-inverted-dropdowns-jp-old';

/**
 ## Address Input
 `address-input` is an address form that works for all countries.

 ```example
 @title Example

 @controller-properties
 {
   address: Ember.Object.create({ // Would normally be Address.create
     addressLine1: '125 Street St',
     addressLine2: 'Apt 2',
     locality: 'San Francisco',
     adminLevel1: 'CA',
     postalCode: '94118',
     countryCode: 'US'
   }),
   actions: {
     fetchDidFail() {},
     updateAddressValidations() {}
   }
 }


 @hbs
 {{addresses/address-input address=address
                           countryAddressData=countryAddressData
                           fetchDidFail=(action "fetchDidFail")
                           updateAddressValidations=(action "updateAddressValidations")
                           validatedController=this
                           labelOverrides=overrides}}
 ```

 ### Parameters
 @param {Object} [address] - Address object used to read/write fields, i.e. Address.create({});
 @param {Object} [countryAddressData=null] - CountryAddressData object from the address service, looked up in the route or when the component loads
 @param {Boolean} [isCountryCodeHidden=false] - Set to `true` to hide the country field entirely
 @param {Boolean} [isCountryCodeDisabled=false] - Set to `true` to show a disabled country field
 @param {Boolean} [useNarrowLayout=false] - Set to `true` to use a narrow layout for width-constrained views
 @param {Object} [fetchDidFail=null] - If present, action to call when a request to AddressService fails
 @param {Object} [updateAddressValidations=null] - If present, action to call with CountryAddressData param when a country is changed to update the validation rules.
 @param {Object} [validatedController=null] - Controller with LGTM validator that will be hooked up to internal validated inputs.
 @param {Object} [isReadOnly=false] - Set to `true` to show address input fields as read-only.
 @param {Object} [labelOverrides] - A hash of <labelKey>:<value> pairs that defines a set of label overrides for form
   fields. This allows for specifying arbitrary strings for each form field. The keys in this object match the method
   names in `CountryAddressDataLocalizer`.
 @param {Boolean} [shouldStorePrefectureAsKanji=false] - If true, this component will update the passed-in address model
   by storing the prefecture name (in kanji) on the model instead of the ISO code.
 @param {Boolean} [useMarketUI=false] - Set to true to show the market versions of the address inputs
*/
let AddressInput = (_dec = tagName(''), _dec2 = readOnly('userInfo.languageCode'), _dec3 = readOnly('userInfo.countryCode'), _dec4 = service('address'), _dec5 = computed('countries.countryNamesByCode'), _dec6 = computed('address.{countryCode,isNew}', 'countryAddressData.{createMethod,editMethod}', 'useMarketUI'), _dec(_class = (_class2 = class AddressInput extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "countries", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    // passed-in
    _defineProperty(this, "address", null);
    _defineProperty(this, "scriptAddresses", null);
    _defineProperty(this, "countryAddressData", null);
    _defineProperty(this, "isCountryCodeHidden", false);
    _defineProperty(this, "isCountryCodeDisabled", false);
    _defineProperty(this, "useNarrowLayout", false);
    _defineProperty(this, "fetchDidFail", null);
    _defineProperty(this, "updateAddressValidations", null);
    _defineProperty(this, "initialJPStateOptions", null);
    _defineProperty(this, "validatedController", null);
    _defineProperty(this, "isReadOnly", false);
    _defineProperty(this, "labelOverrides", null);
    _defineProperty(this, "shouldStorePrefectureAsKanji", false);
    _defineProperty(this, "shouldShowAddressLine2JP", false);
    _defineProperty(this, "useJPScriptAddresses", false);
    _defineProperty(this, "useMarketUI", false);
    // properties
    _initializerDefineProperty(this, "locale", _descriptor3, this);
    _initializerDefineProperty(this, "countryCodeDefault", _descriptor4, this);
    _initializerDefineProperty(this, "addressService", _descriptor5, this);
    _defineProperty(this, "isLoading", false);
  }
  didInsertElement(...args) {
    super.didInsertElement(...args);
    // If countryAddressData is not provided, look it up now
    if (isEmpty(this.countryAddressData)) {
      // Use default country code if not already set
      if (this.address && isEmpty(this.address?.countryCode) && !isEmpty(this.countryCodeDefault)) {
        this.address.set('countryCode', this.countryCodeDefault);
      }
      this.send('fetchCountryMetadata', {
        clearFields: false
      });
    } else {
      const countryAddressData = this.countryAddressData;
      this._handleCountryAddressData({
        countryAddressData
      });
    }
  }

  // Convert map of countries to select-list options
  get countryOptions() {
    return Object.entries(this.countries.countryNamesByCode).map(([code, name]) => ({
      value: code,
      label: name
    })).sortBy('label');
  }

  // Type of layout to use
  get inputTypeComponent() {
    const inputMethod = this.address?.isNew ? this.countryAddressData?.createMethod : this.countryAddressData?.editMethod;
    if (isEmpty(inputMethod)) {
      return null;
    }
    switch (inputMethod) {
      default:
      case CountryAddressData.InputMethod.FORM:
        if (this.useMarketUI) {
          return AddressInputTypeForm;
        }
        return AddressInputTypeFormOld;
      case CountryAddressData.InputMethod.INVERTED_DROPDOWNS:
        if (this.address?.countryCode === 'JP') {
          if (this.useMarketUI) {
            return AddressInputTypeInvertedDropdownsJP;
          }
          return AddressInputTypeInvertedDropdownsJPOld;
        }
        // TODO: Implement inverted dropdowns generically for all countries
        if (this.useMarketUI) {
          return AddressInputTypeForm;
        }
        return AddressInputTypeFormOld;
    }
  }
  fetchCountryMetadata({
    clearFields = true
  }) {
    // Do nothing if no country/locale
    if (isEmpty(this.address?.countryCode)) {
      return;
    }

    // If live validation is active, stop it while data is fetched
    const isLiveValidationEnabled = this.validatedController?.isLiveValidationEnabled;
    if (isLiveValidationEnabled) {
      this.validatedController.stopValidation();
    }
    this.set('isLoading', true);
    this.addressService.lookupCountryAddressData({
      country: this.address?.countryCode,
      locale: this.locale
    }).then(countryAddressData => {
      if (isEmpty(countryAddressData)) {
        throw new Error('Missing countryAddressData');
      }
      this._handleCountryAddressData({
        countryAddressData,
        clearFields,
        isLiveValidationEnabled
      });
    }).catch(error => {
      if (!this.isDestroyed && !this.isDestroying) {
        this.fetchDidFail?.(error);
      }
    }).finally(() => {
      if (!this.isDestroyed && !this.isDestroying) {
        this.set('isLoading', false);
      }
    });
  }
  _handleCountryAddressData({
    countryAddressData,
    clearFields = false,
    isLiveValidationEnabled = false
  }) {
    if (clearFields) {
      this.address.eachAttribute(attribute => {
        if (attribute !== 'countryCode') {
          this.address.set(attribute, undefined);
        }
      });
    }
    // Update address validations on parent controller
    this.updateAddressValidations?.(countryAddressData);
    this.set('countryAddressData', countryAddressData);

    // If live validation is active, run again to pickup address changes
    if (isLiveValidationEnabled) {
      next(this, () => this.validatedController.validateAll());
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "countries", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "locale", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "countryCodeDefault", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "addressService", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "countryOptions", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "countryOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "inputTypeComponent", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "inputTypeComponent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "fetchCountryMetadata", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "fetchCountryMetadata"), _class2.prototype), _class2)) || _class);
export { AddressInput as default };